export var FilterVariant;
(function (FilterVariant) {
    FilterVariant["Operator"] = "Operator";
    FilterVariant["Column"] = "Column";
})(FilterVariant || (FilterVariant = {}));
//# sourceMappingURL=FilterVariant.type.js.map